import dayjs from 'dayjs'
import LocalizedFormat from 'dayjs/plugin/localizedFormat' // import plugin
import relativeTime from 'dayjs/plugin/relativeTime' // import plugin
import utc from 'dayjs/plugin/utc' // import plugin
import 'dayjs/locale/ru' // import locale

dayjs.extend(LocalizedFormat)
dayjs.extend(relativeTime)
dayjs.extend(utc)

dayjs.locale('ru') // use locale

export function useDayJs() {
    return dayjs
}